import { useState } from 'react';
import { Button, Radiogroup } from '@nazka/nazka.mapframe.components';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';

import './layer-group.css';

function LayerGroup({
  title,
  layers = [],
  selectedLayer = null,
  onChange = () => {},
  startOpen = true,
  collapsible = true,
}) {
  const [isOpen, setIsOpen] = useState(startOpen);

  return (
    <div className="layer-group">
      {collapsible && (
        <div className="layer-group__header">
          {title}
          <Button
            icon={isOpen ? faChevronUp : faChevronDown}
            layout="ghost"
            hover={false}
            color="var(--color-common-grey-dark)"
            onClick={() => setIsOpen(prev => !prev)}
          />
        </div>
      )}
      {(!collapsible || isOpen) && (
        <Radiogroup
          className="layer-group__radio-group"
          radios={layers}
          onInputChange={onChange}
          selectedValue={selectedLayer}
        />
      )}
    </div>
  );
}

export default LayerGroup;
